/* COVA revealing text: split into lines, fill each line from left to right while it scrolls through the screen. */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-reveal-text]', function (host) {
      var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger, SplitText = window.SplitText;
      var heading = host.querySelector('h2');
      if (!gsap || !ScrollTrigger || !SplitText || !heading) return;
      gsap.registerPlugin(ScrollTrigger, SplitText);
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      SplitText.create(heading, {
        type: 'lines',
        linesClass: 'cv-rtext__line',
        autoSplit: true, // splits again when web fonts finish loading and when the width changes
        onSplit: function (self) {
          host.classList.add('is-split');
          return self.lines.map(function (line) {
            return gsap.fromTo(line, { backgroundPosition: '100% 0%' }, {
              backgroundPosition: '0% 0%', ease: 'none',
              scrollTrigger: { trigger: line, start: 'top 85%', end: 'bottom 55%', scrub: true }
            });
          });
        }
      });
    });
  });
})();
